export default "__VITE_ASSET__B8_OJ2dU__"